import { OptimizedProviders } from "./components/providers/OptimizedProviders";
import { AuthProvider } from "./components/providers/AuthProvider";
import { ConditionalPresenceProvider } from "./components/providers/ConditionalPresenceProvider";
import { AppRoutes } from "./components/routing/AppRoutes";
import AuthWrapper from "./components/auth/AuthWrapper";
import { useState, useEffect } from "react";
import { useTTSCleanupOnRoute } from './hooks/useTTSCleanupOnRoute';
import { MunicipalityProvider } from "./contexts/MunicipalityContext";

function App() {
  // Check if we're in the Lovable editor
  const hostname = window.location.hostname;
  const isLovableEditor = hostname.includes('lovable.dev') || 
                         hostname.includes('lovableproject.com') ||
                         hostname.includes('lovable.app');

  // Add initialization state
  const [isInitialized, setIsInitialized] = useState(false);
  
  useEffect(() => {
    // Set initialization status after a small delay
    // This helps ensure all providers are properly mounted
    const timer = setTimeout(() => {
      setIsInitialized(true);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <OptimizedProviders>
      <TTSCleanupWrapper>
        {isInitialized ? (
          <AuthProvider>
            {(user) => {
              const isAdminRoute = window.location.pathname.startsWith('/admin');
              return (
                <MunicipalityProvider>
                  <ConditionalPresenceProvider user={user} isAdminRoute={isAdminRoute}>
                    <AuthWrapper>
                      <AppRoutes user={user} isLovableEditor={isLovableEditor} />
                    </AuthWrapper>
                  </ConditionalPresenceProvider>
                </MunicipalityProvider>
              );
            }}
          </AuthProvider>
        ) : (
          <div className="min-h-screen bg-background">
            <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-50">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
            </div>
          </div>
        )}
      </TTSCleanupWrapper>
    </OptimizedProviders>
  );
}

// Wrapper component for TTS cleanup
const TTSCleanupWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useTTSCleanupOnRoute();
  return <>{children}</>;
};

export default App;
